import { NO_PRINT_DATA_ATTRIBUTE } from '../constants';
import { PrintOrientation } from '../types';

const defaultStyles = (
  orientation: PrintOrientation,
  rootSize?: { width: string; height: string }
) => `
@page {
   margin-top: 110px; 
   margin:5mm;
   size: letter ${orientation} !important;
   background: white;
  }
  @media print {
  body {
  /* Tell browsers to print background colors */
        color-adjust: exact; /* Firefox. This is an older version of "print-color-adjust" */
        print-color-adjust: exact; /* Firefox/Safari */
        -webkit-print-color-adjust: exact; /* Chrome/Safari/Edge/Opera */
  }
    html, body {
    height: 100vh; /* Use 100% here to support printing more than a single page*/
    margin:5mm;
    padding: 0 !important;
    /*overflow: hidden;*/
    overflow: visible;
    height: fit-content;
   
    background: white;
  }
}
  #printty-root {
    background: white;
    ${rootSize ? `min-width: ${rootSize.width}; ` : ''}


  }
  /* For Any given element that requests not to be printed, hide visibility */
  [data-${NO_PRINT_DATA_ATTRIBUTE}] {
    visibility: hidden;
  }
`;
export { defaultStyles };
